import { render, staticRenderFns } from "./GeneralInspection.vue?vue&type=template&id=348deef4&scoped=true"
import script from "./GeneralInspection.vue?vue&type=script&lang=js"
export * from "./GeneralInspection.vue?vue&type=script&lang=js"
import style0 from "./GeneralInspection.vue?vue&type=style&index=0&id=348deef4&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348deef4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('348deef4')) {
      api.createRecord('348deef4', component.options)
    } else {
      api.reload('348deef4', component.options)
    }
    module.hot.accept("./GeneralInspection.vue?vue&type=template&id=348deef4&scoped=true", function () {
      api.rerender('348deef4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/postScreening/generalInspection/GeneralInspection.vue"
export default component.exports